module.exports = __webpack_public_path__ + "static/media/DevKitWebApp.b3b40532.svg";